import { helper } from '@ember/component/helper';

export function imageUrl([asset, format]) {
  if (!asset) {
    return;
  }

  if (!format) {
    format = asset.isImage ? 195 : 348;
  }

  const imageUrlTemplate = asset.imageUrlTemplate;
  const newFlag = asset.newPreviewTime ? `?${asset.newPreviewTime}` : '';

  return `${imageUrlTemplate.replace('{ratio}/{width}', format)}${newFlag}`;
}

export default helper(imageUrl);
